import React from 'react';
import { createRoot } from 'react-dom/client';
import { getUUID, removeDom } from '@libs/shared';
import AgentManager from './AgentManager';
import Modal from './components/modal';

const manager = new AgentManager();

/**
 * 打开模态框
 *
 * @param root0
 * @param root0.title
 * @param root0.url
 * @param root0.onClose
 * @param root0.onSuccess
 * @param root0.onMessage
 */
export const openModal = ({
    title,
    url,
    onSuccess,
    onClose,
    onMessage
}: {
    title: string;
    url: string;
    onClose: (id: string) => void;
    onSuccess: (id: string) => void;
    onMessage: (result: unknown) => void;
}) => {
    const $el = document.createElement('div');
    document.body.appendChild($el);
    const root = createRoot($el);
    const id = getUUID();
    manager.registerInstance(id, $el, () => {
        root.unmount();
    });
    root.render(
        <Modal
            title={title}
            url={url}
            onClose={() => {
                closeModal(id);
                onClose(id);
            }}
            onMessage={onMessage}
        />
    );
    onSuccess(id);
};

/**
 * 关闭模态框
 *
 * @param id
 */
export const closeModal = (id: string) => {
    const instance = manager.getInstance(id);
    if (instance) {
        removeDom(instance);
        manager.unRegisterInstance(id);
    }
};
